// Browsers strip tabs/newlines and treat `//host` or `/\host` as another origin; /auth/* targets would log out or loop.
export const toSafeReturnPath = (value: string | null | undefined) =>
  value && /^\/(?![/\\]|auth\/)\S*$/.test(value) ? value : undefined
